import React, { useContext } from "react";
import { HiOutlineArrowSmallLeft } from "react-icons/hi2";
import { Link, useNavigate } from "react-router-dom";
import { ProfileSliderContext } from "../../appContext";
import MobFixedHeader from "../../components/Header/MobFixedTopHeader";

function MobileProfileTopNavigation({ pageTitle }) {
  const navigate = useNavigate();
  
  const handleBack = (pageTitle) => {
      if (pageTitle === "Profile") {
        navigate('/');
      } else {
        navigate('/profile');
      }
  };
  return (
    <MobFixedHeader title={pageTitle} onBack={(pageTitle)=>{handleBack(pageTitle)}} />
  );
}

export default MobileProfileTopNavigation;
